function ViewResult() {
  return (
    <>
      <h1>Development Process</h1>
      <div className="cards">
        <div class="process-container">
          <div class="process-box green">
            <h3>Chess Board</h3>
            <p>
              I created a chessboard design using HTML and CSS Grid, adding
              smooth hover effects to make it more interactive and visually
              appealing. The layout was designed to be clean, responsive, and
              user-friendly. I used the CSS Grid concept to arrange the boxes
              evenly and applied hover styling for an enhanced user experience.
              especially in UI design, layout structuring, and responsive web
              design.
            </p>
            <div className="viewCode">
              <button>
                <a
                  href="https://github.com/ckirankumar456/chessboard.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  view code
                </a>
              </button>
              <button>
                <a
                  href="https://drive.google.com/file/d/1BlkxfOs6rPVqo90zslcAE16QQq0OTvAI/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  view output
                </a>
              </button>
            </div>
          </div>
          <div class="process-box green">
            <h3>Calculator</h3>
            <p>
              I developed a calculator application using HTML, CSS, and
              JavaScript with a clean and user-friendly UI design. The
              calculator performs basic arithmetic operations such as addition,
              subtraction, multiplication, and division. I focused on creating a
              responsive and well-structured layout with neatly arranged buttons
              and smooth hover effects for a better user experience. front-end
              design knowledge.
            </p>
            <div className="viewCode">
              <button>
                <a
                  href="https://github.com/ckirankumar456/Calculator.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  view code
                </a>
              </button>
              <button>
                <a
                  href="https://drive.google.com/file/d/1Kl0YDhvJo2_9kB-EUUwwQBGhUSkfw4L3/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  view output
                </a>
              </button>
            </div>
          </div>
          <div class="process-box green">
            <h3>Image Slides</h3>
            <p>
              I developed an interactive image slider using core JavaScript and
              DOM manipulation. It displays one item at a time, and when a user
              clicks on an item, related category buttons appear dynamically. On
              moving to the next item, these buttons hide automatically. This
              project highlights my skills in JavaScript event handling, DOM
              updates, and dynamic UI design without external frameworks.
            </p>
            <div className="viewCode">
              <button>
                <a
                  href="https://github.com/ckirankumar456/slideImages-web.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  view code
                </a>
              </button>
              <button>
                <a
                  href="https://drive.google.com/file/d/1kV13FnXqi4C30t2cIe7xMmv_6TkzcnFi/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  view output
                </a>
              </button>
            </div>
          </div>
          <div class="process-box green">
            <h3>Figma Project</h3>
            <p>
              I designed and developed a website using React by taking
              inspiration from Figma UI designs. The project focused on creating
              a modern with reusable React components. I worked on improving UI
              consistency, component design, and ensuring an excellent user
              experience. This project helped me enhance my React skills, design
              thinking, and front-end development knowledge.
            </p>
            <div className="viewCode">
              <button>
                <a
                  href="https://github.com/ckirankumar456/FigmaProject.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  view code
                </a>
              </button>
              <button>
                <a
                  href="https://drive.google.com/file/d/1lwGi3SqtfS2M3rXiS8Mpu1nlcaLmh4Pw/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  view output
                </a>
              </button>
            </div>
          </div>
          <div class="process-box blue">
            <h3>E-commerce</h3>
            <p>
              Developed a complete eCommerce website using React.js, Redux
              Toolkit, and React Router. Implemented core features such as
              product selection, Add to Cart, Delete, and Wishlist functionality
              with real-time updates. Utilized React Hooks and Redux Toolkit
              slices for efficient global state management, designed reusable
              components.
            </p>
            <div className="viewCode">
              <button>
                <a
                  href="https://github.com/ckirankumar456/ecom-website.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  view code
                </a>
              </button>
              <button>
                <a
                  href="https://drive.google.com/file/d/1Z7srjcs56hLIcvqMcJlNdPVmB5PcGY97/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  view output
                </a>
              </button>
            </div>
          </div>
          <div class="process-box orange">
            <h3>Text Extract</h3>
            <p>
              I built an OCR Image Text Extraction web app using the MERN stack.
              It uses Tesseract.js for text recognition and jsPDF for creating
              PDFs. Users can upload images, extract and edit text, then
              download clean, formatted PDFs. The frontend was made with
              React.js and React Hooks, and the backend with Node.js,
              Express.js, and MySQL for data storage.
            </p>
            <div className="viewCode">
              <button>
                <a
                  href="https://github.com/ckirankumar456/ocr-image-extract.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  view code
                </a>
              </button>
              <button>
                <a
                  href="https://drive.google.com/file/d/1TpnK9wlzRc3PGjqyYyX13tYPDd4njWe4/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  view output
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewResult;
